module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_02.def1be71.jpg";